import { forwardRef, type InputHTMLAttributes } from 'react'
import styles from './TextField.module.css'

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Подпись над полем */
  label?: string
  /** Текст ошибки под полем */
  errorText?: string | null
}

/**
 * Текстовое поле с подписью и сообщением об ошибке.
 * Используется совместно с React Hook Form через forwardRef.
 * @param label - Подпись над полем
 * @param errorText - Текст ошибки (если есть, поле подсвечивается красным)
 */
export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ label, errorText, id, className = '', ...rest }, ref) => {
    const inputClasses = [
      styles.input,
      errorText ? styles.invalid : '',
      className
    ].filter(Boolean).join(' ')

    return (
      <div className={styles.field}>
        {label && (
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
        )}
        <input ref={ref} id={id} className={inputClasses} {...rest} />
        {errorText && <span className={styles.error}>{errorText}</span>}
      </div>
    )
  }
)

TextField.displayName = 'TextField'
